<template>
    <div class="courseList white_bg paddingV16">
        <div class="inner paddingH12">
            <div class="header clearfix marginB12">
                <div class="titleArea floatL">
                    <div class="title bold" style="font-size: 125%">{{title}}</div>
                    <div class="desc color999">{{desc}}</div>
                </div>
                <div class="opeartionArea fr">
                    <a class="color999" href="">更多 <span class="angleBracketsFont">&gt;</span></a>
                </div>
            </div><!-- end header -->
            <div class="body">
                <div class="list clearfix" :class="layout">
                    <div class="item" v-for="(dataItem, index) in dataList"
                        :key="dataItem.id" @click="viewItem(dataItem)">

                        <!-- 水平3卡片布局 -->
                        <div class="inner" v-if="layout === 'horizontal3CardLayout'">
                            <div class="imageArea marginB8">
                                <img class="cover fullSpace" :src="dataItem.coverImg"/>
                                <div class="descArea f12 white">
                                    共{{dataItem.applyCount}}人学
                                </div>
                            </div>
                            <div class="titleArea font16r color333 bold">{{dataItem.title}}</div>
                        </div>

                        <!-- 纵向图文布局 -->
                        <div class="inner flexLayout" v-if="layout === 'verticalImageTextLayout'">
                            <div class="numberArea" style="width: 26px; padding-top: 30px;">
                                <span v-if="index+1 <= 3" class="icon"
                                      :class="'flag_' + (index+1)"></span>
                                <span class="f14 color333 bold inlineBlock alignCenter" style="width: 16px;"
                                    v-else>{{index+1}}</span>
                            </div>
                            <div class="imageArea" style="width: 120px;">
                                <img class="cover fullSpace" :src="dataItem.coverImg"/>
                            </div>
                            <div class="flexItem paddingL8">
                                <div class="titleArea f18 color333 bold">
                                    {{dataItem.title}}
                                </div>
                                <div class="descArea f12 bold" v-show="dataItem.liveCount > 0">
                                    共{{dataItem.liveCount}}节课
                                </div>
                                <div class="clearfix">
                                    <div class="priceArea floatL">
                                        <strong class="red">￥{{dataItem.price}}</strong>
                                        <span class="textDelete color999" style="font-size: 12px; margin-left: 8px;">
                                            ￥{{dataItem.marketPrice}}
                                        </span>
                                    </div>
                                    <div class="learningArea fr f12 color999" style="padding-top: 4px;">
                                        {{dataItem.applyCount}}人在学
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 水平3卡片布局 -->
                        <div class="inner" v-if="layout === 'table2ColumnCardLayout'">
                            <div class="imageArea marginB8 roundBorder8">
                                <img class="cover fullSpace" :src="dataItem.coverImg"/>
                            </div>
                            <div class="titleArea f15 color333 bold marginB8 textOverflowShowEllipsis">
                                {{dataItem.title}}
                            </div>
                            <div class="descArea f12">
                                共{{dataItem.applyCount}}人学
                            </div>
                        </div>

                    </div>
                </div>
            </div><!-- end .body -->
        </div>
    </div>
</template>

<script>
import modulePart from '@comp/part/modulePart';

const config = {
    apiConfig : {
        list : {
            url : 'portal/courseVod/listForAudience'
        }
    },
    detailPageRoute : ''
};

export default {
    name: "courseModule",
    extends : modulePart,
    data () {
        return {
            apiConfig: config.apiConfig
        }
    },
    methods : {
        viewItem : function (dataItem) {

        }
    },
    mounted() {
        this.pageSize = this.pagination.pageSize = this.itemCount;
        this.apiConfig.list.params = this.dataParams;
        this.loadDataList();
    }
}
</script>

<style lang="scss" scoped>

.horizontal3CardLayout {
    display: flex;
    .item {
        margin-right: 10px;
        flex: 1;
        &:last-child {
            margin-right: 0;
        }
    }

    .imageArea {
        height: 120px;
        border-radius: 8px;
        position: relative;
        overflow: hidden;
    }

    .descArea {
        position: absolute;
        z-index: 1;
        bottom: 0;
        left: 0;
        width: 100%;
        /*height: 20px;*/
        box-sizing: border-box;
        padding: 2px 10px;
        line-height: 20px;
        background-color: rgba(0,0,0,.5);
    }

    .titleArea {
        line-height: 1.25em;
        height: 2.5em;
        overflow: hidden;
    }
}/* end .horizontal3CardLayout */

.verticalImageTextLayout {
    .item {
        margin-bottom: 14px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .numberArea {
        .flag_1 {
            width: 16px;
            height: 22px;
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAsCAYAAAAEuLqPAAABbUlEQVRYhe3TL0gDYRjH8dMJImgQzGI0mC2WGVem5RXu3t97G6YLlgVhccUwNFtNWgRZWbM5hDWLZagYBMdQcU5BdONnEM47dTrn/WHwPvCEJ30/4X0NKlWOcXcNKvUQ455pgAYMIMBxWqxWX+mdYvEpGkAu1+L5eZufJxJAPv/IRqPzJR4ZoFR6doP1eic+QK3WpuO04gFUKi/uHcsb8N6x/AIN0AAN0AANCH41QAMGH1AicBQXYItCJCjEGIG9KAF3lHLV8AwNY4hAgUAzbMAVbXvR6DIEVqjUTTgA4ISmOdst7iIsa55KXQQLAMq0rMnf4i5CiGkqdRwMANhmMjnSa9yDGCew3z8AuCew9tewD1EoDBPY6AdwTSlT/4n7IFKCSt32BgBOqdRcUHEXkcksELj8GQAc0jSngo67iGx2hkpVvwdIucNUajSsuItIpycIHHwAgCaB9bDDPoQQCdr25jvAtpeijPsgwPIbwM3Y+AjpRPAAAAAASUVORK5CYII=');
            background-repeat: no-repeat;
        }
        .flag_2 {
            width: 16px;
            height: 22px;
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAsCAYAAAAEuLqPAAACVElEQVRYhe3UPWgTYRzH8WgFEXQQnMXRwdnFRccu6hKhzXNVnDq4FBEyZnHwDUGom6TPxZYaiRqwOqTSoUVRQQq2Wm0bHJSYvkja3DUvl7uv0yXXkmjumkso5Af/KXC/T563gKIy0cEZDSiSzQ7OUhfQBewtwK0U+lwGQy9hARQMrPQaleFptnwHJGYpVkzqxrIg9ZWyb4BwEs1wlBsmrOuY5cp2xP0p1yvRHCD+iaJdpJewwkk0RbI5lCC/plGlzSy7XoXmAJ8zGFtlrK0yVmqBkvO3Jw5cNo/p6yGsN6/mKdmAX7k2A64/R7NvBMDO1fEVMDhOPrNR23+9hDWUIN82wPcVqnfAMOHeG3QP3/EGmFmm7Lx+jz9S8PhH3ANeztUOHcDrL6733TtA/UDBsmrl79KeXj9vgNuT6M7XcHGVyi7LmweEk2hFo3bdfm9iDo67PvHeAQtZKs59zxWwVjXMnfMt63pVmgMsrmwHNMqq5tNL2HGAj9MFdAF7H/BCSKY7A1C5G4zTE4xzSMQYax9A5U9IcjXgDOwTUSJCsuE34OeA5FygQUSMS4pkzReAkMz2RTnZqNxO/yinFUm6pQChMtE/ytH/ldsJqhxXJG9bAhAqD89OcaDZ8ipimMNC8tQzQKjkRIxrboudiUTYLyQ3vQAyIUnvbsqdCUmEMsJ6UwChMq+onGpVuZ3LI5wRKj/+CRCSyb4xjrW63M6VKCcUlfd1AaERor0POOhXuZ3zjzgiJM+qACHZEJIbfhc7E4zTMyC5o0iWAgOSC+0sd0bEuPgX1OUukZIspmEAAAAASUVORK5CYII=');
            background-repeat: no-repeat;
        }
        .flag_3 {
            width: 16px;
            height: 22px;
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAsCAYAAAAEuLqPAAACaElEQVRYhe3UPYgTQRQH8OgJImghWIulhbWNjZbXqE2Eu8xEsbKwOUQQsQiIiF+FgiIIBgsFcyCKXmaikRAiweP8DhFjDk/lNGAu39nd3O7O/i0Cu7fEeEkuk3CQB6/ZLf4/3sw8DxidGVpzet8DRqtD7PkRYARYZ4D3N1SUsyZMzQIA6DULhZSBuYuKfMCPFzqsZm5LCQPIPGzIA7y7rroDdaBRELBM97fEmbocQCnjJGlLAvGpGhit4tXZun0cAPA11O0UOgQUMya0vICWF0jf1Vz/FhO6DSh+MeVewn917rUD+J3UBwtI3dEgnPyW6UgDzF1SWl5CKdvt+PsIEDrw5nIvu6BHwOx5BVpeuMYvdCB5TtIzbNfxqRqUnLARhZQxWACjVXwOajZguWrJARiKBUNt9ttrqhtwzwHoNUmARtHZduV5E9ETzU0YP1WH+sc5gsqCpEW0EF5uufVaXkAY7qf46bbEPVDKmvhf/XzZ7Rbs4RKmgxrqvwQMtXkkhmKhnDXx8abaQ3gPgP73CDACrHdAhD4GI4nhADi9ipB3DEnvFnDyYJCAIsK+454VBXg2gJEAOKnIBiwi6j/gaVPg5AgYXZID4OQDIhO724U7iMm94PRbnwFkBs8mt68WbiOeeneC0WR/AJzcQmz/pk7DbUTIuxWMTK8BQMrg5GS3wS5EILARnFzoHsBpDhHf+FrCXRDmI2C00CGApBGhe/oVbiOeH90HRr6vAiBRxCZ29DvcRsSO7QKns20AviDC45tlhduIJwe3gZFHKwCkAkZOyw52IULeMTD/lSaA+w8NMtwFiZDDfwE9GI1HJIyOhAAAAABJRU5ErkJggg==');
            background-repeat: no-repeat;
        }

    }
    .imageArea {
        height: 80px;
        border-radius: 8px;
        overflow: hidden;
    }
    .titleArea {
        line-height: 1.33em;
        height: 1.33em;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .descArea {
        line-height: 1.33em;
        height: 1.33em;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 16px;
    }
}/* end .verticalImageTextLayout */

.table2ColumnCardLayout {
    /*padding-left: 10px;*/
    .item {
        float:left;
        width: 50%;
        height: 140px;
        box-sizing: border-box;
        padding-right: 10px;
        margin-bottom: 16px;
    }
    .imageArea {
        height: 80px;
        overflow: hidden;
    }
    .titleArea {
        line-height: 1.33em;
        height: 1.33em;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
    }
    .descArea {
        line-height: 1.33em;
        height: 1.33em;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

</style>
